// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/table/table.css
// module id = 2007
// module chunks = 0